import React, { useState, useEffect } from 'react';
import { Calendar, Layout, Tag } from 'antd';
import TitleAndNew from '../../Components/TitleAndNew/TitleAndNew';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { REQUEST_GET_CALENDAR_DATA } from '../../Redux/constants/constants';
import styles from './styles.module.css';

const { Content } = Layout;

const AdminCalendar = () => {
  const dispatch = useDispatch();
  const calendarData = useSelector((state) => state.calendarData);
  const today = moment().format('YYYY-MM-DD');
  const [currentMonth, setCurrentMonth] = useState(today);

  useEffect(() => {
    dispatch({ type: REQUEST_GET_CALENDAR_DATA, payload: currentMonth });
  }, []);

  useEffect(() => {
    dispatch({ type: REQUEST_GET_CALENDAR_DATA, payload: currentMonth });
  }, [currentMonth]);

  const onPanelChange = (date, mode) => {
    setCurrentMonth(date.format('YYYY-MM-DD'));
  };

  const getDayData = (value) => calendarData[value.format('YYYY-MM-DD')] || [];

  const getColorForTag = (type) => {
    let color;
    switch (type) {
      case 'sickLeave':
        color = 'blue';
        break;
      case 'vacation':
        color = 'green';
        break;
      case 'unpaidLeave':
        color = 'magenta';
        break;
      case 'overtimeLeave':
        color = 'orange';
        break;
    }
    return color;
  };

  const checkToday = (momentObject) => {
    return moment(momentObject).isSame(moment(), 'day');
  };

  const checkWeekend = (momentObject) => {
    const weekday = momentObject.format('dddd');
    return weekday === 'Sunday' || weekday === 'Saturday';
  };

  const checkCurrentMonthDay = (momentObject) => {
    if (moment(momentObject).isSame(new Date(), 'month')) {
      return styles.currentMonthDay;
    } else {
      return styles.otherMonthDay;
    }
  };

  const cellStyle = (momentObject, holiday) => {
    if (checkToday(momentObject)) {
      // color current day
      return styles.todayCell;
    } else if (checkWeekend(momentObject) || holiday.length > 0) {
      // color off days
      return styles.weekendCell;
    } else {
      return styles.cell;
    }
  };

  const dateCellRender = (date) => {
    const dayData = getDayData(date).filter((data) => data.type !== 'holiday');
    return (
      <>
        <div>
          <ul className={styles.scroll} style={{ listStyleType: 'none' }}>
            {dayData.map((item) => (
              <li key={item.content}>
                <Tag color={getColorForTag(item.type)}>{item.content}</Tag>
              </li>
            ))}
          </ul>
        </div>
      </>
    );
  };

  const dateFullCellRender = (date) => {
    const dayData = getDayData(date);
    const holiday = dayData.filter((data) => data.type === 'holiday');
    return (
      <>
        <div className={cellStyle(date, holiday)}>
          <div className={styles.dayLabel}>
            {holiday.length > 0 && (
              <p className={styles.holidayName}>{holiday[0].content}</p>
            )}
            <p className={checkCurrentMonthDay(date)}>
              {date.format('DD').toString()}
            </p>
          </div>
          <div>{dateCellRender(date)}</div>
        </div>
      </>
    );
  };

  function getMonthData(value) {
    // if (value.month() === 8) {
    //   return 1394;
    // }
  }

  function monthCellRender(value) {
    const num = getMonthData(value);
    return num ? (
      <div className="notes-month">
        <section>{num}</section>
        <span>Backlog number</span>
      </div>
    ) : null;
  }

  return (
    <Layout>
      <Content style={{ margin: '36px' }}>
        <TitleAndNew titleText={'Kalendarz'} />
        <div
          style={{
            background: '#fff',
            padding: '16px',
            borderRadius: '8px',
          }}
        >
          <Tag
            style={{ marginLeft: '48px', marginRight: '16px' }}
            color="green"
          >
            Urlop
          </Tag>
          <Tag style={{ marginRight: '16px' }} color="blue">
            Chorobowe
          </Tag>
          <Tag style={{ marginRight: '16px' }} color="orange">
            Urlop z nadgodzin
          </Tag>
          <Tag color="magenta">Urlop niepłatny</Tag>
          <Calendar
            style={{
              background: '#fff',
              padding: '16px',
              borderRadius: '8px',
            }}
            dateCellRender={dateCellRender}
            dateFullCellRender={dateFullCellRender}
            monthCellRender={monthCellRender}
            onPanelChange={onPanelChange}
          />
        </div>
      </Content>
    </Layout>
  );
};

export default AdminCalendar;
